// Import Swiper core module.
import Swiper from 'swiper';

// Import Swiper modules.
// eslint-disable-next-line import/no-unresolved
import { Navigation, Pagination, Autoplay, EffectCube, EffectFade, EffectFlip, EffectCoverflow } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-cube';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-flip';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Configure Swiper to use modules.
Swiper.use([Navigation, Pagination, Autoplay, EffectCube, EffectFade, EffectFlip, EffectCoverflow]);

// Assign Swiper to window so Alpine can call on Swiper.
window.Swiper = Swiper;

export function initQuotesSwiper( element ) {

    const quotesSwiperSpeed = 1500;

    const quotesSwiper = new Swiper(element, {
        slidesPerView: 1,
        loop: false,
        spaceBetween: 0,
        preventInteractionOnTransition: true,
        navigation: {
            nextEl: '.swiper-controls .next',
            prevEl: '.swiper-controls .prev',
        },
        centeredSlides: false,
        speed: quotesSwiperSpeed,
        allowTouchMove: true,
        autoplay: {
            delay: 10000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
        },
        on: {
            init: function (swiper) {
                const activeSlide = swiper.slides[swiper.activeIndex];
                const elementToAnimate = activeSlide.querySelector('[data-animate-lines]');
                if (elementToAnimate) {
                    window.runLinesReveal(elementToAnimate, 'reveal');
                }
            },
            slideChangeTransitionStart: function (swiper ) {
                const prevSlide = swiper.slides[swiper.previousIndex];
                const prevElementToAnimate = prevSlide.querySelector('[data-animate-lines]');

                // Hide previous element.
                if (prevElementToAnimate) {
                    gsap.to(prevElementToAnimate, {
                        duration: quotesSwiperSpeed,
                        opacity: 0,
                        ease: "power2.out",
                    });

                    window.runLinesReveal(prevElementToAnimate, 'hide');
                }

                // Show next element.
                const activeSlide = swiper.slides[swiper.activeIndex];
                const nextElementToAnimate = activeSlide.querySelector('[data-animate-lines]');
                if (nextElementToAnimate) {
                    setTimeout(
                        function() {
                            window.runLinesReveal(nextElementToAnimate, 'reveal');
                    }, (quotesSwiperSpeed / 2));
                }
            },
        },
    });

    quotesSwiper.init();
}

export function icitSwiperLoopFix(swiperEl) {
	if( ! swiperEl.originalSlides ){
		// remember original slides count
		// remember original slides for duplicates
		// remember duplicates
		swiperEl.originalSlides = '';
		swiperEl.duplicateSlides = '';
		swiperEl.originalSlidesCount = swiperEl.swiper.slides.length;
		for( let i = 0; i < swiperEl.originalSlidesCount; i++ ){
			swiperEl.originalSlides += '<div class="max-lg:!w-auto max-w-25 md:max-w-40 lg:max-w-62 xl:max-w-[297px] max-md:!h-25 md:max-lg:!h-40 lg:aspect-square shrink swiper-slide" data-swiper-slide-index="' + i + '">' + swiperEl.swiper.slides[ i ].innerHTML + '</div>';
			swiperEl.duplicateSlides += '<div class="max-lg:!w-auto max-w-25 md:max-w-40 lg:max-w-62 xl:max-w-[297px] max-md:!h-25 md:max-lg:!h-40 lg:aspect-square shrink swiper-slide swiper-slide-duplicate" data-swiper-slide-index="' + i + '">' + swiperEl.swiper.slides[ i ].innerHTML + '</div>';
		}
	}

	// get current slides width and find the smallest one
	let allSlidesWidth = 0;
	let smallestSlideWidth = Infinity;

	for( let i = 0; i < swiperEl.swiper.slides.length; i++ ){
		const slideWidth = swiperEl.swiper.slides[ i ].offsetWidth;

		allSlidesWidth += slideWidth;

		if( smallestSlideWidth > slideWidth ){
			smallestSlideWidth = slideWidth;
		}
	}

	// if all slides are smaller than swiper area and smallest slide
	const neededDuplicatesCount = Math.ceil( ( swiperEl.swiper.size + smallestSlideWidth ) / allSlidesWidth ) - 1;

	if( neededDuplicatesCount > 0 ){
		const currentDuplicatesCount = swiperEl.swiper.slides.length / swiperEl.originalSlidesCount - 1;

		// reset slides because of possible changed order and mix with duplicates
		// add duplicates
		swiperEl.swiper.slidesEl.innerHTML = swiperEl.originalSlides + swiperEl.duplicateSlides.repeat( currentDuplicatesCount + neededDuplicatesCount );

		swiperEl.swiper.update();

		requestAnimationFrame(function(){
			swiperEl.swiper.loopFix();

			if( swiperEl.swiper.autoplay.paused ){
				swiperEl.swiper.autoplay.start();
			}
		});
	}
}
